import { Routes } from '@angular/router';
import {ResolvePagingParams} from '../../core/services';
import {Authority} from '../../shared/constants/authority.constants';
import {UserRouteAccessService} from '../../core';
import {CurrencyComponent} from './currency-list/currency.component';

export const currencyRoute: Routes = [
  {
    path: '',
    component: CurrencyComponent,
    resolve: {
      pagingParams: ResolvePagingParams
    },
    data: {
      authorities: [Authority.ADMIN],
      defaultSort: 'id,desc',
      title: 'Currency'
    },
    canActivate: [UserRouteAccessService]
  }
];
